@if (!is_loaded) {
    <app-loading-indicator></app-loading-indicator>
} @else if (is_loaded && player.id) {
    <app-tab-group [sticky_class]="true" [content_min_height]="'0'">
        @for (tab of tabs; track tab) {
            <app-tab>
                <app-tab-label>
                    <app-app-string class="label" [key_name]="tab.label" (click)="postAnalytistTab(tab.event)"></app-app-string>
                </app-tab-label>
                <app-tab-content>
                    <app-sponsor-banner-signal
                        location="player-details-top"
                        sponsor_key="player-details-top"
                        aspect_ratio="9:1"
                        style="margin-top: 10px"
                    ></app-sponsor-banner-signal>
                    @if (tab.type === 'stats') {
                        <div class="section-header">
                            <app-app-string class="label" [key_name]="'tennis.players.details.label'"></app-app-string>
                        </div>
                        <section class="details-container">
                            @for (item of details_keys; track item) {
                                @if (correspondingValues(item)) {
                                    <div class="row">
                                        <app-app-string class="label" [key_name]="item.key"></app-app-string>
                                        <div class="stat">{{ getDetail(item.value) }}</div>
                                    </div>
                                }
                            }
                        </section>
                    }
                    @if (tab.type === 'news') {
                        @if (articles.length > 0) {
                            <section class="player-news-list">
                                @for (item of articles; track item.id) {
                                    <article class="player-news-item" (click)="openLink(item)">
                                        <div class="player-news-image">
                                            <app-image [image_url]="item.image_url" [width]="'100%'" [height]="'100%'" [border_radius]="'14px'" [type]="item.type"></app-image>
                                        </div>
                                        <div class="player-news-content">
                                            @if (item.title !== null && item.title !== '') {
                                                <h3 class="player-news-title">
                                                    {{ item.title }}
                                                </h3>
                                            }
                                            @if (item.publication_date) {
                                                <time class="player-news-date">{{ getArticleDate(item) }}</time>
                                            }
                                        </div>
                                    </article>
                                }
                            </section>
                            @if (!articlesCompleted) {
                                <div
                                    class="player-news-pagination"
                                    appIntersectionObserver
                                    [threshold]="0.1"
                                    [isContinuous]="true"
                                    (isIntersecting)="handleNewsPagination($event)"
                                >
                                    @if (loadingArticles) {
                                        <app-loading-indicator></app-loading-indicator>
                                    }
                                </div>
                            }
                        } @else if (loadingArticles) {
                            <div class="player-news-loading">
                                <app-loading-indicator></app-loading-indicator>
                            </div>
                        }
                    }
                    @if (tab.type === 'matches') {
                        @if (faceoffs.data.length) {
                            <div class="section-header">
                                <app-app-string class="label" [key_name]="'tennis.players.previous.matches'"></app-app-string>
                            </div>
                        }
                        @for (item of sortedFaceoffsByTour; track item) {
                            <section class="faceoff-container">
                                <div class="section-header" style="margin-left: 1rem">
                                    {{ item?.name }}
                                </div>
                                @for (faceoff of item.faceoffs; track faceoff) {
                                    <app-tennis-match [from_player_history]="true" [round]="faceoff.round" [faceoff]="faceoff" [attr.data-match-id]="faceoff.id"></app-tennis-match>
                                }
                            </section>
                        }
                        @if (faceoffs.data.length && !faceoffs_ready) {
                            <div align="center" style="margin: 1em 0">
                                <mat-spinner></mat-spinner>
                            </div>
                        }
                        @if (faceoffs.data.length) {
                            <section id="last-section" style="height: 1px; width: 100%; visibility: hidden"></section>
                        }
                    }
                </app-tab-content>
            </app-tab>
        }
    </app-tab-group>
}
